import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check_unselected",
  "use": "icon-check_unselected-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check_unselected\"><path d=\"M128 725.333333V298.666667a170.666667 170.666667 0 0 1 170.666667-170.666667h426.666666a170.666667 170.666667 0 0 1 170.666667 170.666667v426.666666a170.666667 170.666667 0 0 1-170.666667 170.666667H298.666667a170.666667 170.666667 0 0 1-170.666667-170.666667z m85.333333 0q0 35.328 25.002667 60.330667T298.666667 810.666667h426.666666q35.328 0 60.330667-25.002667T810.666667 725.333333V298.666667q0-35.328-25.002667-60.330667T725.333333 213.333333H298.666667q-35.328 0-60.330667 25.002667T213.333333 298.666667v426.666666z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/check_unselected.svg
// module id = XFfb
// module chunks = 10